import React from 'react';

import { Web } from '@mui/icons-material';
import { Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { Breadcrumbs, DriverSolutionsMenuItem, SubHeader } from '../../../../components';

import './styles.scoped.css';

const MENU_ITEMS = [
  {
    text: 'Manually Billed Expense needs to move to Transmitted',
    icon: '',
    to: '/expense-entry/expense-maintenance/manual-expense',
  },
  {
    text: 'Expense Deleted in EDGE needs reset to Ready to Bill',
    icon: '',
    to: '/expense-entry/expense-maintenance/deleted-expense',
  },
  {
    text: 'Download and reupload receipt to locked expenses',
    icon: '',
    to: '/expense-entry/expense-maintenance/receipt-expense',
  },
];

const ExpenseMaintenance = () => {
  const navigate = useNavigate();

  return (
    <>
      <SubHeader
        text="Expenses"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
        popoverTitle="Need help with your Expenses?"
      />
      <Breadcrumbs leftTitle="Expense Maintenance" route="/expense-entry" />
      <Container className="wrap">
        <Row className="row">
          {MENU_ITEMS.map(item => (
            <DriverSolutionsMenuItem
              key={item.to}
              text={item.text}
              icon={item.icon}
              onPress={() => navigate(item.to)}
            />
          ))}
        </Row>
      </Container>
    </>
  );
};

export default ExpenseMaintenance;
